import { useThemeStore } from "@stores/theme.store";
import moment from "moment";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const StudentViolationsDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Pelanggaran",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Pelanggaran", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Pelanggaran</div>
        <div className="color-theme mb-3">{moment(state.tanggal ?? Date.now()).format('dddd, DD MMMM YYYY | HH:mm')}</div>
        <div className="color-highlight">Pelanggaran Dilakukan</div>
        <div className="color-theme mb-3">{state.pelanggaran ?? '-'}</div>
        <div className="color-highlight">Tidakan Pelanggaran</div>
        <div className="color-theme mb-3">{state.tindakan ?? '-'}</div>
        <div className="color-highlight">Poin Pelanggaran</div>
        <div className="color-theme mb-3">{state.poin} Poin</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state.catatan ?? '-'}</div>
      </div>
    </div>
  );
};
